module.exports = __webpack_public_path__ + "static/media/popup_pattern.e800cffe.svg";